module.exports = __webpack_public_path__ + "static/img/M5.878d8c39.png";